import { message } from 'antd';

import { call, put, takeEvery, all, fork } from 'redux-saga/effects'
import {FETCH_SITES, FETCH_SITES_START, FETCH_SITES_SUCCESS, FETCH_SITES_ERROR } from "../../actions/admin/sitesActions";
import { getAllSites } from "../../../services/sites-service";

function* fetchSites() {
    try {
        yield put({ type: FETCH_SITES_START })
        const response = yield call(getAllSites);
        if (response.success) {
            yield put({ type: FETCH_SITES_SUCCESS, sites: response.sites })
        } else {
            yield put({ type: FETCH_SITES_ERROR, error: response.error })
            message.error('Failed to fetch sites!');
        }
    } catch (error) {
        yield put({ type: FETCH_SITES_ERROR, error })
        message.error('Failed to fetch sites!');
    }
}

function* sitesWatcher() {
    yield takeEvery(FETCH_SITES, fetchSites)
}

export default function* rootSaga() {
    yield all([
        sitesWatcher(),
    ]);
}